"use strict";

App.Pages.Notices = class Notices extends PF.Page {

    static get options() {
        return {
            rights: {
                user: true
            },
            path: '/notices',
            nameRu: 'Уведомления',
        };
    }

    static get template() {
        //language=HTML
        return `
			<div id="Notices" data-page="Notices" class="page navbar-fixed">

				<div class="page-content ptr-content" pf="pageContent">

                    <div class="page-header">
                        <h3>Уведомления</h3>
                    </div>

<!--					<div class="ptr-preloader">-->
<!--						<div class="preloader"></div>-->
<!--						<div class="ptr-arrow"></div>-->
<!--					</div>-->

					<div class="stretch-block-hidden">
						<div class="card list" pf="list">

						</div>
<!--						<div style="text-align: center; margin-top: 32px;">-->
<!--							<span class="preloader preloader-red" pf="preloader"></span>-->
<!--						</div>-->
<!--						<div class="block" style="text-align: center; display: none;" pf="dummy">-->
<!--							Вы пока не получали уведомлений-->
<!--						</div>-->
					</div>

				</div>

			</div>

		`;
    }

    init() {
        super.init();

        this.list = new PF.List({
            dom: {
                element: this.dom.list,
            },
            modelsConfig: {
                represent: 'notice/viewAll',
                limit: 10,
            },
            dummyText: "<p style='text-align: center'>Вы пока не получали уведомления</p>",
            itemClass: (list, model) => App.Pages.Notices[model.noticeType.code],
        });
    }
};
//
// App.Pages.Notices.List = class List extends MK.Array
// 	{
// 	get itemRenderer()
// 		{
// 		return `
// 			<div class="card" pf="card"></div>
// 			`;
// 		}
//
// 	get Model()
// 		{
// 		return App.Pages.Notices.Notice;
// 		}
//
// 	constructor(sandbox, dataArray)
// 		{
// 		super();
// 		this.dataArray = dataArray;
// 		this.bindSandbox(sandbox);
//
// 		this.dataArray.on('push-item', this.pushSlot.bind(this));
//
// 		this.viewed = [];
// 		this.viewedMap = {};
//
//
// 		this.saveReadedInterval = setInterval(this.saveReaded.bind(this), 300);
// 		}
//
// 	recreate()
// 		{
// 		this.splice(0, this.length);
// 		for (let i = 0; i < this.dataArray.length; i++)
// 			{
// 			let item = new App.Pages.Notices[this.dataArray[i].noticeType.code](this.dataArray[i]);
// 			item.on('viewed', this.setViewed.bind(this));
// 			this.push(item);
// 			}
// 		}
//
// 	pushSlot(dataItem)
// 		{
// 		let item = new App.Pages.Notices[dataItem.noticeType.code](dataItem, this, this.length);
// 		item.on('viewed', this.setViewed.bind(this));
// 		this.push(item);
// 		}
//
// 	setViewed(item)
// 		{
// 		if (this.viewedMap[item.noticeData.id] !== true)
// 			{
// 			this.viewed.push(item);
// 			this.viewedMap[item.noticeData.id] = true;
// 			}
// 		}
//
// 	saveReaded()
// 		{
// 		if (this.viewed.length > 0)
// 			{
// 			let saveArray = [];
// 			for (let i = 0; i < this.viewed.length; i++)
// 				{
// 				this.viewed[i].noticeData.notice2User.read = "1";
// 				this.viewed[i].read = true;
// 				saveArray.push(this.viewed[i].noticeData.notice2User);
// 				this.viewedMap[this.viewed[i].noticeData.id] = undefined;
// 				}
// 			this.viewed.splice(0, this.viewed.length);
//
// 			app.ajax('/represent/save?represent=notice2User/saveRead', {rows: JSON.stringify(saveArray)}, (response) => {
// 				// for(let i=0;i<response.data.length;i++)
// 				console.log(response);
// 				app.getNoticeCount();
// 			});
//
// 			}
//
// 		}
//
//
// 	};